import React, { useState, useEffect } from 'react';
import api from '../config/api';
import { resolvePartnerLogoUrl } from '../utils/partnerLogos';
import { useLanguage } from '../context/LanguageContext';
import PageMeta from '../components/PageMeta';
import './Partners.css';

const Partners = () => {
  const { t, language } = useLanguage();
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get('/partners');
        if (!cancelled) setPartners(Array.isArray(data) ? data : []);
      } catch (e) {
        console.error('Failed to load partners', e);
        if (!cancelled) setPartners([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="partners-page">
      <PageMeta
        title={t('seo.partners.title')}
        description={t('seo.partners.description')}
        path="/partenaires"
        locale={language}
      />
      <div className="container">
        <h1 className="page-title">{t('partners.title')}</h1>
        
        {loading ? (
          <p className="partners-loading">{t('home.loading')}</p>
        ) : (
        <div className="partners-grid">
          {partners.map((partner) => {
            const imagePath = resolvePartnerLogoUrl(partner.logoUrl);
            if (!imagePath) return null;
            const content = (
              <div className="partner-item">
                <img 
                  src={imagePath} 
                  alt={partner.name}
                  className="partner-image"
                />
              </div>
            );

            if (partner.websiteUrl) {
              return (
                <a
                  key={partner._id}
                  href={partner.websiteUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="partner-link-wrapper"
                  title={partner.name}
                >
                  {content}
                </a>
              );
            }

            return (
              <div key={partner._id} className="partner-link-wrapper" title={partner.name}>
                {content}
              </div>
            );
          })}
        </div>
        )}
      </div>
    </div>
  );
};

export default Partners;


